import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_TraceWorksheetAnalysis = _resolveComponent("TraceWorksheetAnalysis")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_UserNotification = _resolveComponent("UserNotification")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      "is-active": $setup.isWaiting,
      title: "Loading policy documents..."
    }, null, 8 /* PROPS */, ["is-active"]),
    _createVNode(_component_TraceWorksheetAnalysis, {
      isActive: $setup.analyzerActive,
      docUrl: $setup.analyzerDocUrl,
      onClosed: $setup.analyzerClosed
    }, null, 8 /* PROPS */, ["isActive", "docUrl", "onClosed"]),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          justify: "space-between",
          class: "justify-sm-center justify-xs-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "d-flex justify-start" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, "Policy Number: " + _toDisplayString($setup.policyNumber), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_tabs, {
          modelValue: $setup.tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tab) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, { value: "1" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Trace Worksheets")
              ])),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_v_tabs_window, {
          modelValue: $setup.tab,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.tab) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs_window_item, { value: "1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    ($setup.errorMessage.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_container, {
                          key: 0,
                          class: "px-0"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errorMessage, (error, index) => {
                              return (_openBlock(), _createBlock(_component_UserNotification, {
                                key: index,
                                message: error.content,
                                closable: true
                              }, null, 8 /* PROPS */, ["message"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_data_table, {
                      headers: $setup.headers,
                      items: $setup.policyDocs || [],
                      class: "text-left elevation-1 mt-6",
                      "item-key": "correlationId",
                      hover: "",
                      color: "primaryMoe",
                      "items-per-page": $setup.itemsPerPage,
                      "sort-by": [{ key: 'lastModified', order: 'desc' }],
                      "footer-props": {
							itemsPerPageOptions: [5, 10, 25, 50, -1],
							itemsPerPageText: 'Documents per page:',
							showFirstLastPage: true
						}
                    }, {
                      "item.createdOn": _withCtx(({ item }) => [
                        _createTextVNode(_toDisplayString($setup.moment.utc(item.createdOn).local().format('MM/DD/YYYY h:mm:ss A')), 1 /* TEXT */)
                      ]),
                      "item.lastModified": _withCtx(({ item }) => [
                        _createTextVNode(_toDisplayString($setup.moment.utc(item.lastModified).local().format('MM/DD/YYYY h:mm:ss A')), 1 /* TEXT */)
                      ]),
                      "item.download": _withCtx(({ item }) => [
                        _createVNode(_component_v_icon, {
                          color: "primary",
                          onClick: ($event: any) => ($setup.downloadFile(item.docUrl)),
                          style: {"cursor":"pointer"}
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode(" mdi-download ")
                          ])),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                      ]),
                      "item.analyze": _withCtx(({ item }) => [
                        _createVNode(_component_v_icon, {
                          color: "primary",
                          onClick: ($event: any) => ($setup.openAnalyzer(item.docUrl)),
                          style: {"cursor":"pointer"},
                          title: "Open in Trace Worksheet Analyzer"
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode(" mdi-file-search-outline ")
                          ])),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["headers", "items", "items-per-page"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}